import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
  SupportedPluginContentfulDataType,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import loadable from "@loadable/component";
import { HeroGalleryProps } from "./HeroGalleryWrapper";
import { productPageLayouts } from "../pluginOwners";

export const HeroGalleryComponent: ComponentToBeRegistered<HeroGalleryProps> = {
  placeholder: Placeholder.Hero,
  Component: loadable(() => import("./HeroGalleryWrapper")),
  name: "HeroGalleryWrapper",
  dataNeeds: {
    contentful: {
      heroDefaultAltText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Hero Gallery Default Alt Text",
      },
      heroThumbnailAltText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Hero Thumbnail Default Alt Text",
      },
      heroImageAltTextPrefix: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Hero Image > Larger Alt Text",
      },
      vortexToggleView: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex > Toggle View",
      },
      vortexLoadError: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex > Load Error",
      },
      vortexLoadingPreview: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex > Loading Preview",
      },
      vortexActionsFront: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex Actions > Front",
      },
      vortexActionsBack: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex Actions > Back",
      },
      vortexActionsFolded: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex Actions > Folded",
      },
      vortexActionsUnfolded: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex Actions > Unfolded",
      },
      vortexActionsOpen: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex Actions > Open",
      },
      vortexActionsClose: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Vortex Actions > Close",
      },
      heroGalleryAriaLabel: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Hero gallery aria label",
      },
      heroThumbnailAriaLabel: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Hero thumbnail aria label",
      },
      heroImageAriaLabel: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Hero image aria label",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    return true;
  },
};

export const heroGallery: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, HeroGalleryComponent);
  },
  pluginOwner: productPageLayouts,
};
